export default __webpack_public_path__ + "static/video-preview-2-6b322c959aa2031bf0a93bee26be5678.webp";